export const homeServicesMock = [
  {
    id: 1,
    icon: 'icon-split',
    translationKey: 'splitPayment',
  },
  {
    id: 2,
    icon: 'icon-chat',
    translationKey: 'customerService',
  },
  {
    id: 3,
    icon: 'icon-truck',
    translationKey: 'worldwideShipping',
  },
  {
    id: 4,
    icon: 'icon-all',
    translationKey: 'rewardPoints',
  },
];

export const categoryServicesMock = [
  {
    id: 1,
    icon: 'icon-split',
    translationKey: 'splitPayment',
  },
  {
    id: 2,
    icon: 'icon-chat',
    translationKey: 'customerService',
  },
  {
    id: 3,
    icon: 'icon-truck',
    translationKey: 'worldwideShipping',
  },
  {
    id: 4,
    icon: 'icon-all',
    translationKey: 'rewardPoints',
  },
];

export const productServicesMock = [
  {
    id: 1,
    icon: 'icon-split',
    translationKey: 'splitPayment',
  },
  {
    id: 2,
    icon: 'icon-chat',
    translationKey: 'customerService',
  },
  {
    id: 3,
    icon: 'icon-truck',
    translationKey: 'worldwideShipping',
  },
  {
    id: 4,
    icon: 'icon-all',
    translationKey: 'rewardPoints',
  },
];
